import {
    useMemo,
} from 'react'
import isString from 'lodash/isString'
import useLabel from 'app/hooks/useLabel'

import {
    FormError,
} from 'app/types/common.types'
import useStyles from './FormErrorLabels.styles'

type Props = {
    error: FormError
    id: string
}
const FormErrorLabels = ({
    error, id,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const replaceErrorFields = (template: string, values: string[]) => {
        return values.reduce((acc, value) => {
            return acc.replace(/%s/, value)
        }, template)
    }

    const labels = useMemo(() => {
        return error.fields?.map((field) => {
            return l(`${id}.${field}`) || field
        })
    }, [
        error.fields,
        id,
        l,
    ])

    if (!labels || labels.length === 0) {
        return (
            <span className={classes.spanWrapper}>
                {error.message || (isString(error) ? String(error) : null)}
            </span>
        )
    }

    return (
        <>
            {labels.map((label, i) => {
                return (
                    <span
                        key={label || i}
                        className={classes.spanWrapper}
                    >
                        {`${label}: `}
                        {error.message.includes('%') ? replaceErrorFields(error.message, labels) : error.message}
                    </span>
                )
            })}
        </>
    )
}

export default FormErrorLabels
